export default __webpack_public_path__ + "e8e9b34d684450cdbeb847bbf24d069d.svg";